import { render, staticRenderFns } from "./EnrollPatient.vue?vue&type=template&id=d68d56a2&scoped=true&"
import script from "./EnrollPatient.vue?vue&type=script&lang=js&"
export * from "./EnrollPatient.vue?vue&type=script&lang=js&"
import style0 from "./EnrollPatient.vue?vue&type=style&index=0&id=d68d56a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68d56a2",
  null
  
)

export default component.exports